import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-row tcv" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "tcv-left-padder me-1" }, null, -1)
const _hoisted_3 = { class: "d-flex flex-column single-city-wrapper flex-grow-1" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", { class: "m-1" }, null, -1)
const _hoisted_5 = { class: "text-center small text-nowrap" }
const _hoisted_6 = {
  key: 1,
  class: "text-center small text-nowrap day-label day-time"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "w-100 d-flex flex-row justify-content-center tcv-exit-dots" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-ellipsis-h" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_point_modal_content = _resolveComponent("point-modal-content")!
  const _component_point_list_item = _resolveComponent("point-list-item")!
  const _component_point_travel_info = _resolveComponent("point-travel-info")!
  const _component_city_point_time = _resolveComponent("city-point-time")!
  const _component_overnight_modal_content = _resolveComponent("overnight-modal-content")!
  const _component_point_list = _resolveComponent("point-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_point_list_item, {
        class: "tcv-stay-at flex-grow-1",
        name: _ctx.singlePoints['stay_at'].name.value,
        "allow-settings": !!_ctx.modelValue.stay_at,
        "allow-centering": true,
        "allow-delete": false,
        handle: false,
        onSearchComplete: _cache[0] || (_cache[0] = ($event: any) => (_ctx.singlePoints['stay_at'].change($event))),
        onCenterOnThis: _cache[1] || (_cache[1] = ($event: any) => (_ctx.singlePoints['stay_at'].centerMap())),
        "icon-class": _ctx.singlePoints['stay_at'].iconClass.value,
        "item-class": "tcv-hoverable",
        "item-description": "Stay Somewhere?",
        "item-hover": "Home sweet home. Sleep here, then go out and explore!",
        onMouseover: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setHoverPoint(_ctx.modelValue.stay_at))),
        onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.clearHoverPoint(_ctx.modelValue.stay_at)))
      }, {
        settings: _withCtx(() => [
          _createVNode(_component_point_modal_content, {
            modelValue: _ctx.modelValue.stay_at,
            "onUpdate:modelValue": _ctx.singlePoints['stay_at'].boundSet
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ]),
        _: 1
      }, 8, ["name", "allow-settings", "icon-class"]),
      _hoisted_4,
      _createVNode(_component_point_list_item, {
        class: "tcv-enter flex-grow-1 mb-1",
        name: _ctx.singlePoints['enter_via'].name.value,
        "allow-inline": true,
        "allow-settings": !!_ctx.modelValue.enter_via,
        "allow-centering": true,
        "allow-delete": false,
        handle: false,
        onSearchComplete: _cache[4] || (_cache[4] = ($event: any) => (_ctx.singlePoints['enter_via'].change($event))),
        onCenterOnThis: _cache[5] || (_cache[5] = ($event: any) => (_ctx.singlePoints['enter_via'].centerMap())),
        "icon-class": _ctx.singlePoints['enter_via'].iconClass.value,
        "item-class": "tcv-hoverable",
        "item-description": "Arrival",
        "item-hover": "Arrival point for your plane, train, or magic carpet.",
        style: _normalizeStyle(_ctx.startBottomBorderStyle),
        onMouseover: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setHoverPoint(_ctx.modelValue.enter_via))),
        onMouseleave: _cache[7] || (_cache[7] = ($event: any) => (_ctx.clearHoverPoint(_ctx.modelValue.enter_via)))
      }, {
        inline: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.getDayDisplayString(0)), 1)
        ]),
        settings: _withCtx(() => [
          _createVNode(_component_point_modal_content, {
            modelValue: _ctx.modelValue.enter_via,
            "onUpdate:modelValue": _ctx.singlePoints['enter_via'].boundSet
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ]),
        _: 1
      }, 8, ["name", "allow-settings", "icon-class", "style"]),
      (_ctx.modelValue.enter_via)
        ? (_openBlock(), _createBlock(_component_point_travel_info, {
            key: 0,
            modelValue: _ctx.modelValue.enter_via,
            route: _ctx.legOptions.values[_ctx.modelValue.enter_via.id].options,
            "onUpdate:modelValue": _ctx.singlePoints['enter_via'].boundSet
          }, null, 8, ["modelValue", "route", "onUpdate:modelValue"]))
        : _createCommentVNode("", true),
      _createVNode(_component_point_list, {
        class: "city-point-list flex-grow-1",
        modelValue: _ctx.normalizedPoints,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.normalizedPoints) = $event)),
        onAddSearched: _ctx.addSearched,
        "id-icon-map": _ctx.iconMap,
        "id-border-map": _ctx.borderMap,
        "item-class": "tcv-hoverable",
        onItemHoverStart: _ctx.setHoverPoint,
        onItemHoverEnd: _ctx.clearHoverPoint
      }, {
        inline: _withCtx(({point, updatePoint}) => [
          _createElementVNode("div", null, [
            (!point.is_overnight)
              ? (_openBlock(), _createBlock(_component_city_point_time, {
                  key: 0,
                  modelValue: point,
                  "start-time": _ctx.getTimeInfo(point.id, 'startTime'),
                  "end-time": _ctx.getTimeInfo(point.id, 'endTime'),
                  "use-time-of-day": _ctx.displayOpts.useConcreteTime,
                  "onUpdate:modelValue": updatePoint
                }, null, 8, ["modelValue", "start-time", "end-time", "use-time-of-day", "onUpdate:modelValue"]))
              : (point.is_overnight)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.getDayDisplayString(_ctx.normalizedDays.values[point.id].day)), 1))
                : _createCommentVNode("", true)
          ])
        ]),
        settings: _withCtx(({point, updatePoint}) => [
          (!point.is_overnight)
            ? (_openBlock(), _createBlock(_component_point_modal_content, {
                key: 0,
                modelValue: point,
                "onUpdate:modelValue": updatePoint
              }, null, 8, ["modelValue", "onUpdate:modelValue"]))
            : (point.is_overnight)
              ? (_openBlock(), _createBlock(_component_overnight_modal_content, {
                  key: 1,
                  modelValue: point,
                  "onUpdate:modelValue": updatePoint,
                  "default-hour": _ctx.defaultDayHour,
                  "default-minute": _ctx.defaultDayMinute
                }, null, 8, ["modelValue", "onUpdate:modelValue", "default-hour", "default-minute"]))
              : _createCommentVNode("", true)
        ]),
        intermediate: _withCtx(({point, updatePoint}) => [
          (_ctx.showPointTravelOptions(point.id))
            ? (_openBlock(), _createBlock(_component_point_travel_info, {
                key: 0,
                modelValue: point,
                route: _ctx.legOptions.values[point.id].options,
                "onUpdate:modelValue": updatePoint
              }, null, 8, ["modelValue", "route", "onUpdate:modelValue"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue", "onAddSearched", "id-icon-map", "id-border-map", "onItemHoverStart", "onItemHoverEnd"]),
      _hoisted_7,
      _createVNode(_component_point_list_item, {
        class: "tcv-exit flex-grow-1",
        name: _ctx.singlePoints['exit_via'].name.value,
        "allow-settings": !!_ctx.modelValue.exit_via,
        "allow-centering": true,
        "allow-delete": false,
        handle: false,
        onSearchComplete: _cache[9] || (_cache[9] = ($event: any) => (_ctx.singlePoints['exit_via'].change($event))),
        onCenterOnThis: _cache[10] || (_cache[10] = ($event: any) => (_ctx.singlePoints['exit_via'].centerMap())),
        "icon-class": _ctx.singlePoints['exit_via'].iconClass.value,
        "item-class": "tcv-hoverable",
        "item-description": "Departure",
        "item-hover": "Depart from here, headed to your next adventure.",
        onMouseover: _cache[11] || (_cache[11] = ($event: any) => (_ctx.setHoverPoint(_ctx.modelValue.exit_via))),
        onMouseleave: _cache[12] || (_cache[12] = ($event: any) => (_ctx.clearHoverPoint(_ctx.modelValue.exit_via)))
      }, {
        settings: _withCtx(() => [
          _createVNode(_component_point_modal_content, {
            modelValue: _ctx.modelValue.exit_via,
            "onUpdate:modelValue": _ctx.singlePoints['exit_via'].boundSet
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ]),
        _: 1
      }, 8, ["name", "allow-settings", "icon-class"])
    ])
  ]))
}